const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/emails/forms/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/emails/forms/$id/")({
  beforeLoad: ({
    params
  }) => {
    redirect({
      to: "/settings/emails/forms/$id/$tab",
      params: {
        id: params.id,
        tab: "edit"
      },
      replace: true,
      throw: true,
      search: true,
      state: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});